export default "__VITE_ASSET__4cCWhSio__"